import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useIsMobile } from '@scramble/hooks';
import { Button } from '@scramble/ui';
import IconSuccess from './success.svg';
import s from './index.module.scss';

const id = MODAL_IDS.bank_account_under_review;

export const BankAccountUnderReviewModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

export const Modal = () => {
  const isMobile = useIsMobile();
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const onClose = () => {
    closeModal(id);
  };

  const content = (
    <div className={s.modal}>
      <div className={s.content}>
        <img src={IconSuccess} alt="icon" width={56} height={56} />
        <div className={s.title}>
          {t('bank_accounts:bank_acc_review_modal.title')}
        </div>
        <div className={s.desc}>
          {t('bank_accounts:bank_acc_review_modal.desc')}
        </div>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="filled"
          size="lg"
          label={t('bank_accounts:bank_acc_review_modal.got_it')}
          onClick={onClose}
        />
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalCenterLayout>
  );
};
